import { render, staticRenderFns } from "./WhatsAppContactInfoCard.vue?vue&type=template&id=e9177df2&"
import script from "./WhatsAppContactInfoCard.vue?vue&type=script&lang=js&"
export * from "./WhatsAppContactInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports